<div class="cat-grid pad8">
  <h6 class="padl8 partial-border-top title-text-color fs-4 font600">
    {{buttonsInfo.display_name}}
  </h6>
  <ion-row>
    <ion-col *ngFor="let item of buttonsInfo.smallIcons">
      <ion-card class="pad8" (click)="navigateToPage(item?.landing_url, item?.title)">
        <ion-img [src]="item?.carousel_img"></ion-img>
      </ion-card>
      <p class="fs-2 font500 ion-text-center ion-no-margin paragraph-primary-text-color">{{item?.title}}</p>
    </ion-col>
  </ion-row>
</div>